var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContentCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "content_copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 0.666748H2.99996C2.26663 0.666748 1.66663 1.26675 1.66663 2.00008V11.3334H2.99996V2.00008H11V0.666748ZM13 3.33341H5.66663C4.93329 3.33341 4.33329 3.93341 4.33329 4.66675V14.0001C4.33329 14.7334 4.93329 15.3334 5.66663 15.3334H13C13.7333 15.3334 14.3333 14.7334 14.3333 14.0001V4.66675C14.3333 3.93341 13.7333 3.33341 13 3.33341ZM13 14.0001H5.66663V4.66675H13V14.0001Z",
    fill: "#25292E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContentCopy);
export default __webpack_public_path__ + "static/media/icon_content_copy.06e47c77e100a8385784f3024fcb75c8.svg";
export { ForwardRef as ReactComponent };